<template>
    <div class="text-center loader">
        <div class="loader__icon"></div>
        <div v-if="message" class="loader__message"
             style="width: 100%; font-size: 1rem!important;">
            {{message}}
        </div>
    </div>
</template>
<script>
export default{
  data () {
    return {
      loading: true
    }
  },
  props: {
    size: {
      default: '6'
    },
    message: {
      default: 'Подождите, Аларм План загружает данные...'
    },
    color: {
      type: String,
      default: '#36a9e1'
    }
  },
  methods: {
    getSize () {
      return this.size + 10 + 'px'
    }
  },
  computed: {
    diamondStyle () {
      let size = parseInt(this.size) * 20
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      }
    },
    styles () {
      let size = parseInt(this.size) * 20
      return {
        width: this.size * 20 + 'px',
        height: size / 4 + 'px'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Loading.vue?04258db0